import React from 'react'
import { useNavigate } from 'react-router-dom'
import AuthFormContainer from '../../styled/auth-form-container'
import { PrimaryButton, SecondaryButton } from '../../styled/button'

export default () => {
  const navigate = useNavigate()

  return (
    <AuthFormContainer>
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>📧</div>
        <h2 style={{ color: '#4CAF50', marginBottom: '1.5rem', fontSize: '1.8rem' }}>Check Your Email</h2>
        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '1rem', fontSize: '1.05rem' }}>
          We've sent you an email with a password reset link.
        </p>
        <p style={{ color: '#666', lineHeight: '1.8', marginBottom: '2rem', fontSize: '1.05rem' }}>
          Click the link in the email to set your new password.
        </p>
        <div
          style={{
            background: '#f5f5f5',
            padding: '1.5rem',
            borderRadius: '8px',
            marginBottom: '2rem',
            border: '1px solid #e0e0e0'
          }}
        >
          <p style={{ color: '#555', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
            <strong>Didn't receive the email?</strong><br />
            Check your spam or junk folder. The email should arrive within a few minutes.
          </p>
        </div>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <PrimaryButton onClick={() => navigate('/login')}>
            Back to Login
          </PrimaryButton>
          <SecondaryButton onClick={() => navigate('/forgot-password')}>
            Resend Email
          </SecondaryButton>
        </div>
      </div>
    </AuthFormContainer>
  )
}
